// @flow
import SettingProfileLinks from './SettingProfileLinks';

export default SettingProfileLinks;



// WEBPACK FOOTER //
// ./src/components/settings/SettingProfileLinks/index.js